import { jsx, jsxs, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { isFunction } from "../../../utils/type-checking/type-checking.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { LockSolid as n } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/lock-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import MUIInputAdornment from "../../../../node_modules/@mui/material/InputAdornment/InputAdornment.es.js";
import { IconButton } from "../../icon-button/icon-button.es.js";
function computeLabelProps({
  readonly,
  InputLabelProps: InputLabelProps2
}) {
  return {
    shrink: readonly,
    ...InputLabelProps2
  };
}
function computeInputProps({
  size,
  readonly,
  blocked,
  startIcon,
  endIcon,
  startAdornment,
  endAdornment,
  onStartIconClick,
  onEndIconClick,
  onStartAdornmentClick,
  onEndAdornmentClick,
  InputProps: InputProps2
}) {
  const isNotEditable = readonly ?? blocked;
  let generatedInputProps = {
    readOnly: isNotEditable
  };
  if (blocked) {
    return {
      ...generatedInputProps,
      endAdornment: /* @__PURE__ */ jsx(n, { color: "primary" }),
      className: "blocked"
    };
  }
  if (startIcon || startAdornment) {
    generatedInputProps = {
      ...generatedInputProps,
      startAdornment: getAdornmentAndIcon({
        position: "start",
        size,
        icon: startIcon,
        adornment: startAdornment,
        onIconClick: onStartIconClick,
        onAdornmentClick: onStartAdornmentClick
      })
    };
  }
  if (endIcon || endAdornment) {
    generatedInputProps = {
      ...generatedInputProps,
      endAdornment: getAdornmentAndIcon({
        position: "end",
        size,
        icon: endIcon,
        adornment: endAdornment,
        onIconClick: onEndIconClick,
        onAdornmentClick: onEndAdornmentClick
      })
    };
  }
  return {
    ...generatedInputProps,
    ...InputProps2
  };
}
function getAdornmentAndIcon({
  position,
  size,
  icon,
  adornment,
  onIconClick,
  onAdornmentClick
}) {
  if (position === "start") {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      getTextFieldInputAdornmentProperty("adornment", position, size, adornment, onAdornmentClick),
      getTextFieldInputAdornmentProperty("icon", position, size, icon, onIconClick)
    ] });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    getTextFieldInputAdornmentProperty("icon", position, size, icon, onIconClick),
    getTextFieldInputAdornmentProperty("adornment", position, size, adornment, onAdornmentClick)
  ] });
}
function getTextFieldInputAdornmentProperty(type, position, size, icon, onClick) {
  if (icon) {
    const adornmentClass = type === "icon" ? "icon" : "adornment";
    const adornmentSize = size ?? "medium";
    const inputAdornmentClassName = `${adornmentClass} ${adornmentSize} ${adornmentClass}-${position}`;
    const testID = `text-field-${position}-${adornmentClass}-${adornmentSize}`;
    const testIDForIconButton = `${testID}-button`;
    return /* @__PURE__ */ jsx(MUIInputAdornment, { className: inputAdornmentClassName, position, "data-testid": testID, children: isFunction(onClick) ? /* @__PURE__ */ jsx(IconButton, { "data-testid": testIDForIconButton, size, onClick, children: icon }) : icon });
  }
  return /* @__PURE__ */ jsx(Fragment, {});
}
export {
  computeInputProps,
  computeLabelProps,
  getAdornmentAndIcon,
  getTextFieldInputAdornmentProperty
};
//# sourceMappingURL=text-field-functions.es.js.map
